"use strict";
exports.__esModule = true;
var angular = require("angular");
var broadcast_config_1 = require("../broadcast-config");
require('./compare-to.component.css');
var COMPONENT_NAME = 'smartorg.r6.reportOptions.compareTo';
var BOX_PLACE_HOLDER = 'Drag a node from Navigation panel and drop it here';
function setCompareNodeInfo(node) {
    if (node) {
        var c = document.createElement('div');
        c.id = 'compare.' + node['_id'];
        c.innerText = node['name'];
        c.textContent = node['name'];
        c.style.color = 'black';
        c.style.fontStyle = 'normal';
        var compareAreaElement = angular.element('#compareArea');
        compareAreaElement.empty();
        compareAreaElement.append(c);
    }
}
var CompareToComponent = /** @class */ (function () {
    function CompareToComponent($scope) {
        var ctrl = this;
        $scope.$on(broadcast_config_1["default"].COMPARE_SET, function (event, args) {
            setCompareNodeInfo(args.node);
        });
        $scope.$on(broadcast_config_1["default"].COMPARE_CLEAR, function () {
            ctrl.clearCompareArea();
        });
    }
    /**
     * Used in template: clear button.
     */
    CompareToComponent.prototype.clearCompareArea = function () {
        var compareAreaElement = angular.element('#compareArea');
        compareAreaElement.empty();
        compareAreaElement.text(BOX_PLACE_HOLDER);
    };
    return CompareToComponent;
}());
angular.module(COMPONENT_NAME, []).component('compareTo', {
    template: require('./compare-to.component.html'),
    bindings: {
        updateCompareTo: '&',
        showAlert: '&?'
    },
    controller: CompareToComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=compare-to.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/compare-to/compare-to.component.js